import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const useFetchProjectTracker = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProjects = useCallback(async () => {
    const url = '/api/Project/get-project-by-user';
    setLoading(true);

    try {
      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const processedData = response.data.map((item) => ({
        ...item,
        ProjectPhase: item.projectPhase,
        AFEName: item.name,
        description: item.description || 'N/A',
        netSuiteId: item.netSuiteId || 'N/A',
        asset: item.asset || 'N/A',
        afeNumber: item.afeNumber || 'N/A',
        projectManager: item.projectManager || 'N/A',
        pepApprovalDate: item.pepApprovalDate,
        efcBudget: item.efcBudget || 'N/A',
        lastModifiedDate: item.lastModifiedDate ? new Date(item.lastModifiedDate).toLocaleDateString() : 'N/A',
        portfolioProject: item.portfolioProject || 'N/A',
        type: item.type || 'N/A',
        namePlateCapacity: item.namePlateCapacity || 'N/A',
        unit: item.unit || 'N/A',
        overallComplete: item.overallComplete ?? 0,
        estReadyForService: item.estReadyForService,
        icaApprovalDate: item.icaApprovalDate,
        baselineReadyForService: item.baselineReadyForService,
        mechanicalComplete: item.mechanicalComplete,
        dateAfeCloseRequestSent: item.dateAfeCloseRequestSent,
        rowAcquired: item.rowAcquired || 'N/A',
        enviroSurvey: item.enviroSurvey || 'N/A',
        detailedSurvey: item.detailedSurvey || 'N/A',
        constructionMobd: item.constructionMobd || 'N/A',
        icaExecution: item.icaExecution || 'N/A',
        readyForService: item.readyForService,
        gisInServiceDate: item.gisInServiceDate,
        gisLifeCycleStatus: item.gisLifeCycleStatus || 'N/A',
        firstFlowDate: item.firstFlowDate,
        qptmName: item.qptmName || 'N/A',
        locId: item.locId || 'N/A',
        actuals: item.actuals || 0,
        committed: item.committed || 0,
        fixedCost: item.fixedCost || 0,
        baseCost: item.baseCost || 0,
        budgetCost: item.budgetCost || 0,
        efc: item.efc || 0,
        remainingContingency: item.remainingContingency || 0,
        overUnderBudget: item.efc && item.budgetCost ? item.efc - item.budgetCost : null,
        contingencyPct: item.contingencyPct || null,
        totalCostPerFoot: item.totalCostPerFoot || 0,
        costPerInMile: item.costPerInMile || 0,
        costPerRod: item.costPerRod || 0,
        costPerFootRow: item.costPerFootRow || 0,
        costPerBhp: item.costPerBhp || 0,
        variancePct: item.variancePct || null,
        remainingForecast: item.remainingForecast || 0,
        contingencyUsed: item.contingencyUsed || 0,
        gpsX: item.gpsX,
        gpsY: item.gpsY,
      }));

      setProjects(processedData);
      setError(null);
    } catch (err) {
      console.error('Error fetching project data:', err);
      setError(err.response?.data?.message || err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  return { projects, loading, error, refetch: fetchProjects };
};

export default useFetchProjectTracker;
